import { render, staticRenderFns } from "./GetCompanySize.vue?vue&type=template&id=5944876a&scoped=true&"
import script from "./GetCompanySize.vue?vue&type=script&lang=js&"
export * from "./GetCompanySize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944876a",
  null
  
)

export default component.exports